import { call, put, select } from "redux-saga/effects";
import api, { makeOptions } from "@/services/api";

import IndicadoresActions from "@/store/ducks/indicadores/totais-gerais";

const getAuthData = state => state.auth.data;

export function* request(action) {
  try {
    const authData = yield select(getAuthData);
    const url = `indicadores/totais-gerais`;
    const { data: retorno } = yield call(api.get, url, makeOptions(authData));

    if (retorno.success) {
      yield put(IndicadoresActions.success(retorno.data));
    } else {
      yield put(IndicadoresActions.failure(retorno.message));
    }
  } catch (error) {
    yield put(IndicadoresActions.failure("Erro ao se comunicar com a api"));
  }
}
